export type FounderId = "alobaidi" | "suraihi" | "manea"

export type FounderProfile = {
  id: FounderId
  fullName: string
  title: string
  email: string
  phone: string
  profileUrl: string
  photo: string
}

export const companyProfile = {
  name: "SKILLFITS",
  website: "https://skillfits.com",
  location: "Qatar Science & Technology Park (QSTP), Office: 292-210, Building Number: 115, Street: 2322, Zone: 51",
  incubation: "QSTP Incubated",
} as const

export const founderProfiles: FounderProfile[] = [
  {
    id: "manea",
    fullName: "Manea Al-Asaadi",
    title: "Co-Founder",
    email: "manea@skillfits.com",
    phone: "+974-31321288",
    profileUrl: "https://skillfits.com/contact/manea",
    photo: "/team/Manea pic.jpeg",
  },
  {
    id: "alobaidi",
    fullName: "Abdulrahman Alobaidi",
    title: "Co-Founder",
    email: "a.alobaidi@skillfits.com",
    phone: "+974-6676 7177",
    profileUrl: "https://skillfits.com/contact/alobaidi",
    photo: "/team/Abdulrahman pic.jpeg",
  },
  {
    id: "suraihi",
    fullName: "Abdullah Alsuraihi",
    title: "Co-Founder",
    email: "suraihi@skillfits.com",
    phone: "+974-59971727",
    profileUrl: "https://skillfits.com/contact/suraihi",
    photo: "/team/Abdullah pic.jpeg",
  },
] as const

export const socialLinks = [
  {
    platform: "Facebook",
    url: "https://facebook.com/SkillFitsAI",
  },
  {
    platform: "Instagram",
    url: "https://instagram.com/skillfits.ai",
  },
  {
    platform: "LinkedIn",
    url: "https://linkedin.com/company/skillfits",
  },
] as const

export function getFounderProfile(id: string) {
  return founderProfiles.find((founder) => founder.id === id)
}

function splitFounderName(fullName: string) {
  const trimmedName = fullName.trim()
  const nameParts = trimmedName.split(/\s+/)

  if (nameParts.length <= 1) {
    return {
      firstName: trimmedName,
      lastName: "",
    }
  }

  return {
    firstName: nameParts.slice(0, -1).join(" "),
    lastName: nameParts[nameParts.length - 1],
  }
}

export function buildFounderVCard(founder: FounderProfile) {
  const { firstName, lastName } = splitFounderName(founder.fullName)

  return [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `N:${lastName};${firstName};;;`,
    `FN:${founder.fullName}`,
    `ORG:${companyProfile.name}`,
    `TITLE:${founder.title}`,
    `TEL;TYPE=CELL:${founder.phone.replace(/\s+/g, "")}`,
    `EMAIL;TYPE=INTERNET:${founder.email}`,
    `URL:${founder.profileUrl}`,
    `ADR;TYPE=WORK:;;${companyProfile.location};;;`,
    "END:VCARD",
  ].join("\n")
}